export default "__VITE_ASSET__CdoXFcwG__"